module.exports = __webpack_public_path__ + "img/icon-msds-institute.94045936.svg";